import { Logo } from "@paribus/shared-ui";

import { TutorialCard } from "./TutorialCard";
import type { TutorialVideo } from "./types";

interface TutorialsViewProps {
  tutorials: TutorialVideo[];
  isLoading: boolean;
  hasError: boolean;
}

export const TutorialsView = ({ tutorials, isLoading, hasError }: TutorialsViewProps) => {
  return (
    <div className="min-h-screen bg-surface-subtle">
      <header className="sticky top-0 z-sticky border-b border-border-subtle/50 bg-card/80 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Logo size="md" />
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tight text-foreground">Tutorials Videos</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Learn how to invite physicians, add managers, and onboard your firm quickly.
          </p>
        </div>

        {isLoading && <p className="mt-8 text-sm text-muted-foreground">Loading tutorials...</p>}

        {hasError && (
          <p className="mt-8 rounded-lg border border-destructive-border bg-destructive-subtle px-4 py-3 text-sm text-destructive-text">
            We could not load tutorials right now. Please try again shortly.
          </p>
        )}

        {!isLoading && !hasError && tutorials.length === 0 && (
          <p className="mt-8 rounded-lg border border-border bg-card px-4 py-3 text-sm text-muted-foreground">
            No tutorials are available yet.
          </p>
        )}

        {!isLoading && !hasError && tutorials.length > 0 && (
          <section className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
            {tutorials.map((tutorial) => (
              <TutorialCard key={tutorial.id} tutorial={tutorial} />
            ))}
          </section>
        )}
      </main>
    </div>
  );
};
